import { networkService } from './network';

/**
 * Initialize all offline services
 * Call this once when the app starts
 */
export const initializeOfflineServices = async (): Promise<void> => {
  try {
    // Initialize network service
    await networkService.initialize();

  } catch (error) {
    console.error('Failed to initialize offline services:', error);
  }
};

/**
 * Cleanup offline services
 * Call this when the app is about to be destroyed
 */
export const cleanupOfflineServices = (): void => {
  try {
    networkService.cleanup();
  } catch (error) {
    console.error('Failed to cleanup offline services:', error);
  }
};